import HexAuthWrapper from "../../components/HexAuthWrapper";
import { OrderPayment } from "../../containers/Order";

const OrderPaymentPage = () => {
  return (
    <div>
      <HexAuthWrapper>
        <OrderPayment />
      </HexAuthWrapper>
    </div>
  );
};

export default OrderPaymentPage;
